/**
 * @category Internals
 */
export function createCredentials(source) {
    return {
        suid: source.uid,
        sgid: source.gid,
        euid: source.uid,
        egid: source.gid,
        groups: [],
        ...source,
    };
}
/**
 * Returns true if the credentials can be used for an operation that requires root privileges.
 * @internal
 * @category Internals
 */
export function credentialsAllowRoot(cred) {
    if (!cred)
        return false;
    return !cred.uid || !cred.gid || !cred.euid || !cred.egid || cred.groups.some(gid => !gid);
}
